module.exports = __webpack_public_path__ + "static/media/conserva.1f64a104.png";